import { render, staticRenderFns } from "./Television.vue?vue&type=template&id=415d4934&scoped=true&"
import script from "./Television.vue?vue&type=script&lang=js&"
export * from "./Television.vue?vue&type=script&lang=js&"
import style0 from "./Television.vue?vue&type=style&index=0&id=415d4934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415d4934",
  null
  
)

export default component.exports